<template>
  <div class="about">
    <div class="container">
      <div class="main">
        <div class="text">
          <h2>关于我们</h2>
          <h3>About</h3>
					<div class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
						<p v-for="item in $t('about.details')" :style="imgClass">{{item.text}}</p>
					</div>
        </div>
        <div class="img">
          <img class="wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20" src="../../assets/about01.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data() {
    return{
      imgClass: ''
    };
  },
	mounted(){
		var options={ live:false};
    var wow=new this.$wow.WOW(options).init();
	},
  created(){
    var lang =  sessionStorage.getItem('locale');
    var imgClass = "";
    if (lang == "en") {
      imgClass = {"line-height": 1.3}
    } else{
      imgClass = "";
    }
    this.imgClass = imgClass;
  }
}
</script>

<style>
.about{
  width: 100%;
  background: #fff;
  padding: 50px 0;
}
.about .main{
  width: 100%;
  position: relative;
}
.about .text{
  width: 63%;
  padding: 5%;
  padding-right: 11.5%;
  box-sizing: border-box;
  background: #eff1f5;
}
.about .text h2{
	color: #333;
}
.about .text h3{
	color: #666;
}
.about .text p{
  color: #999;
}
.about .text h3{
  margin-bottom: 30px;
}
.about .text p{
  margin: 0;
  font-size: 12px;
	line-height: 24px;
  margin-bottom: 20px;
}
.about .img{
  width: 44%;
  height: 351px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  overflow: hidden;
}
.about .img img{
  width: 100%;
  display: block;
}

@media (max-width: 992px){
  .about .text{
    width: 100%;
    padding-right: 5%;
		padding-top: 60px;
  }
  .about .text h2{
    font-size: 18px;
  }
  .about .img{
    position: static;
    width: 100%;
    transform: translateY(0);
    padding: 5%;
    background: #eff1f5;
    box-sizing: border-box;
    margin-top: -1px;
		height: auto;
		padding-bottom: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/index/about.vue